const initialData = {
    ipAddressData: {}
};

const ipAddressReducers = (state = initialData, action) => {
    switch (action.type) {
        case "IP_ADDRESS_DATA":
            const { data } = action.payload;
            return {
                ...state,
                ipAddressData: data
            };
        default:
            return state; // Explicitly return the current state for unknown actions
    }
};

export default ipAddressReducers;
